module.exports = __webpack_public_path__ + "static/img/gif.d41623d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/gif.gif
// module id = KA46
// module chunks = 1